import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { authService } from "../services/auth";

const ForgetPass = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      // Assumindo que authService.sendPasswordResetEmail existe ou será implementado
      await authService.sendPasswordResetEmail(email);
      setMessage(
        "Se as credenciais estiverem corretas, um email de recuperação foi enviado."
      );
      setEmail(""); // Limpa o campo de email
    } catch (err) {
      setError(err.message || "Erro ao enviar instruções de recuperação.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="app"
      className="min-h-screen bg-neutral-50 flex items-center justify-center"
    >
      <div className="w-full max-w-md">
        <div className="bg-white shadow-lg rounded-lg p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src="https://i.imgur.com/cRpaPnC.jpeg"
              alt="Logo"
              className="h-12 w-50 mx-auto"
            />
            <h2 className="mt-4 text-2xl">Recuperar Senha</h2>
            <p className="mt-2 text-sm text-neutral-500">
              Digite seu email para receber instruções de recuperação
            </p>
          </div>

          {error && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6"
              role="alert"
            >
              {error}
            </div>
          )}
          {message && (
            <div
              className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-6"
              role="alert"
            >
              {message}
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleResetPassword}>
            <div className="space-y-6">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm text-neutral-700"
                >
                  Email
                </label>
                <div className="mt-1 relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="text-neutral-500"
                    />
                  </div>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="block w-full pl-10 pr-3 py-2 border border-neutral-300 rounded-md focus:ring-1 focus:ring-neutral-500 focus:border-neutral-500"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-white bg-neutral-900 hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? "Enviando..." : "Enviar instruções"}
              </button>
            </div>
          </form>

          {/* Links */}
          <div className="mt-6 text-center text-sm">
            <span
              onClick={() => navigate("/")}
              className="text-neutral-600 hover:text-neutral-900 cursor-pointer"
            >
              Voltar ao login
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPass;
